import { compose, branch, renderComponent } from 'recompose'
import PATCodeForm from './PATCodeForm'
import ImmobilizerCodeForm from './ImmobilizerCodeForm'

export default compose(
  branch(
    ({ codeType }) => (codeType === 'PAT'),
    renderComponent(PATCodeForm)
  ),
)(ImmobilizerCodeForm)



// WEBPACK FOOTER //
// ./components/PATSCodes/CodeForm.js